import React, { createContext, useState, useEffect } from 'react';

const GlobalContext = createContext();

// Create a provider component
const GlobalProvider = ({ children }) => {
  const prevGeolocation = document.getElementById('geolocation')?.value;
  const [isH2H, setIsH2H] = useState(false);
  const [h2hWager, setH2HWager] = useState(0);
  const [h2hCount, setH2HCount] = useState(0);
  const [h2hOpponent, setH2HOpponent] = useState('');
  const [payout, setPayout] = useState(0);
  const [geolocation, setGeolocation] = useState(prevGeolocation);
  const isAdmin = !!document.getElementById('wpadminbar');
  const [multiplier, setMultiplier] = useState(null);
  const [multiplierType, setMultiplierType] = useState(null);
  const [protectedMultipliers, setProtectedMultipliers] = useState([]);
  const [payoutAdjustmentDetails, setPayoutAdjustmentDetails] = useState(null);

  useEffect(() => {
    const h2hWager = document.getElementById('h2h-wager')?.value;
    const h2hCount = document.getElementById('h2h-count')?.value;
    const h2hOpponent = document.getElementById('h2h-name')?.value;
    if (h2hWager && h2hCount) {
      setH2HWager(h2hWager);
      setH2HCount(h2hCount);
      setH2HOpponent(h2hOpponent);
      setIsH2H(true);
    }
  }, []);

  const contextValues = {
    isH2H,
    setIsH2H,
    payout,
    setPayout,
    geolocation,
    setGeolocation,
    isAdmin,
    h2hWager,
    h2hCount,
    h2hOpponent,
    multiplier,
    setMultiplier,
    multiplierType,
    setMultiplierType,
    protectedMultipliers,
    setProtectedMultipliers,
    payoutAdjustmentDetails,
    setPayoutAdjustmentDetails,
  }

  return (
    <GlobalContext.Provider value={{ ...contextValues }}>
      {children}
    </GlobalContext.Provider>
  );
};

export { GlobalContext, GlobalProvider };
